<template>
<div class="chapter">
<div class="inner_page">
<h2 class="praise">Praise for the Queens of Camelot</h2>
<p class="center"><span class="bold"><em class="italic">Risa: In Camelot’s Shadow </em></span></p>
<p class="noindent1">“Based on the famous poem ‘Sir Gawain and the Green Knight,’ this novel delivers passion, danger and excitement laced with fantasy.” —<em class="italic">Romantic Times Bookclub</em></p>
<p class="noindent1">“Sarah Zettel incorporates elements of Arthurian legend into her story with flair, skill and lyrical writing. … <em class="italic">In Camelot’s Shadow </em>is an engrossing and spellbinding tale and I can hardly wait for the sequel!” —<em class="italic">Bookloons</em></p>
<p class="noindent1">“Zettel has brilliantly made a familiar story fresh and vibrant. The story just sings.” —<em class="italic">Romantic Science Fiction &amp; Fantasy</em></p>
<p class="center"><span class="bold"><em class="italic">Elen: For Camelot’s Honor</em></span></p>
<p class="noindent1">“An exciting and seductive journey laced with plenty of magic and romance.” —<em class="italic">Romantic Times Book Reviews</em></p>
<p class="noindent1">“An intriguing story that fans of Arthurian legend will not want to miss.” —<em class="italic">CataRomance Reviews</em></p>
<p class="center"><span class="bold"><em class="italic">Lynet: Under Camelot’s Banner</em></span></p>
<p class="noindent1">“High fantasy at its best.” —SFF Chronicles</p>
<p class="noindent1">“[<em class="italic">Under Camelot’s Banner</em>] is a blend of legend, myth and fantasy. … The author demonstrates a passion for the classic Arthurian story.” —Historical Novel Society</p>
<p class="center"><span class="bold"><em class="italic">Laurel: By Camelot’s Blood</em></span></p>
<p class="noindent1">“A real happy ending takes love, effort, and sacrifice. Pick up a copy of <em class="italic">Camelot’s Blood </em>if you want an epic romance!” —Silver Petticoat Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?277b0abc